import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, User } from "lucide-react";

export const NavLink = ({ href, children, testId, onClick, className = "" }) => (
  <Link to={href} data-testid={testId} onClick={onClick} className={`nav-link text-[13px] uppercase tracking-[0.18em] text-stone-600 hover:text-stone-900 transition-colors duration-300 ${className}`}>
    {children}
  </Link>
);

export const LangToggle = ({ lang, setLang }) => (
  <div className="flex items-center rounded-full border border-stone-300 p-0.5 text-[11px] font-mono uppercase tracking-wider" data-testid="language-toggle">
    {["fr", "en"].map((l) => (
      <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)} className={`px-2.5 py-1 rounded-full transition-all duration-300 ${lang === l ? "bg-stone-900 text-[#FAF7F2]" : "text-stone-500 hover:text-stone-900"}`}>
        {l.toUpperCase()}
      </button>
    ))}
  </div>
);

export const AccountLink = ({ label }) => (
  <Link to="/compte" data-testid="account-link" aria-label={label} className="hidden sm:flex w-9 h-9 rounded-full border border-stone-300 items-center justify-center text-stone-600 hover:bg-stone-900 hover:text-white transition-colors duration-300">
    <User size={15} />
  </Link>
);

export const CartButton = ({ label, count, onClick }) => (
  <button data-testid="cart-drawer-trigger" onClick={onClick} className="relative flex items-center gap-2 rounded-full bg-stone-900 text-[#FAF7F2] px-4 py-2 text-[12px] uppercase tracking-[0.15em] hover:bg-[#C85A32] transition-colors duration-300">
    <ShoppingBag size={14} />
    <span className="hidden sm:inline">{label}</span>
    {count > 0 && (
      <span data-testid="cart-count-badge" className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#C85A32] text-white text-[10px] flex items-center justify-center font-mono">{count}</span>
    )}
  </button>
);

export const MobileMenu = ({ open, links, accountLabel, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }} className="md:hidden overflow-hidden border-t border-stone-200/70 mt-3" data-testid="mobile-menu">
        <div className="px-6 py-5 flex flex-col gap-4">
          {links.map((l) => <NavLink key={l.id} href={l.href} testId={`mobile-nav-${l.id}`} onClick={onClose} className="text-[14px]">{l.label}</NavLink>)}
          <NavLink href="/compte" testId="mobile-nav-account" onClick={onClose} className="text-[14px] pt-3 border-t border-stone-200/70">{accountLabel}</NavLink>
        </div>
      </motion.nav>
    )}
  </AnimatePresence>
);
